import { get, post, postJson,putOne } from '../axios2'

const BASE_PATH = '/question';

// 调查问卷详情
export const getActivity = id => get(`${BASE_PATH}/detail/${id}`);
// 保存
export const saveOrUpdate = (data) =>postJson(`${BASE_PATH}/save`,data);